<div class="eventq-schedule-block">
  <p class="eventq-schedule-block__heading">{{ heading() }}</p>
  @if (time(); as blockTime) {
    <p class="eventq-schedule-block__time">{{ blockTime }}</p>
  }
</div>
